import type { ColumnDef } from '@/shared/types/table-filters.types';
import type { Education, EducationLevel } from '../types/education.types';
import { EDUCATION_LEVEL_LABELS } from '../types/education.types';

const EDUCATION_LEVELS: EducationLevel[] = [
  'HIGH_SCHOOL',
  'ASSOCIATE',
  'BACHELOR',
  'MASTER',
  'PHD',
];

function textColumn(
  key: string,
  label: string,
  accessor: (education: Education) => unknown
): ColumnDef<Education> {
  return { key, label, filterType: 'text', accessor, sortable: true };
}

/**
 * Filterable/sortable education fields.
 * Years stay numbers so they sort numerically; the text filter matches on the digits.
 */
export const educationTableColumns: ColumnDef<Education>[] = [
  textColumn('institution', 'Institution', (education) => education.institution),
  textColumn('educationField', 'Field', (education) => education.educationField),
  {
    key: 'educationLevel',
    label: 'Level',
    filterType: 'select',
    accessor: (education) => education.educationLevel,
    options: EDUCATION_LEVELS,
    optionLabels: EDUCATION_LEVEL_LABELS,
    sortable: true,
  },
  textColumn('city', 'City', (education) => education.city),
  textColumn('country', 'Country', (education) => education.country),
  textColumn('yearBegin', 'Year From', (education) => education.yearBegin),
  textColumn('yearEnd', 'Year To', (education) => education.yearEnd),
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (education) => education.createdAt,
    sortable: true,
  },
];
